var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.columns.includes(_vm.prop))?_c('div',{staticClass:"has-text-centered"},[_c('span',{staticClass:"tickbox"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }